import ApiClient from './client';
import { ErrorService } from '@/services/error-service.js';




const path = require('path');


class UsergroupsAPI extends ApiClient{

  async getUsergroupsRoles() {
    const url = path.join(`${this.USERGROUP_API_PATH}`, `user-group-roles/`);
    let response;
    try {
      response = await this.get(url);
      if (response.status === 200) {
        return response.data;
      }
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  async getUsergroupsTypes() {
    const url = 
      path.join(`${this.USERGROUP_API_PATH}`, `user-group-types/`);
    const response = await this.get(url);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getUsergroupsList(usergroupTypes, searchQuery, controller) {
    let url = 
      path.join(`${this.USERGROUP_API_PATH}`, `user-groups/?usergroup_type=${usergroupTypes.join(',')}`);
    if (searchQuery) {
      url = url + `&search=${searchQuery}`;
    }
    const response = await this.get(url, {
      ...controller && { signal: controller.signal }
    });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async createUsergroup(data) {
    const url = 
      path.join(`${this.USERGROUP_API_PATH}`, `user-groups/`
    );
    const response = await this.post(url, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }

  async updateUsergroup(id, data) {
    const url = 
      path.join(`${this.USERGROUP_API_PATH}`, `user-groups/${id}/`);
    const response = await this.put(url, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getUsergroupMembers(id) {
    const url = path.join(`${this.USERGROUP_API_PATH}`, `user-groups/${id}/members/`);
    const response = await this.get(url);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async addUserToUsergroup(usergroupId, data) {
    try {
      const url = path.join(`${this.USERGROUP_API_PATH}`, `user-groups/${usergroupId}/registered/`);
      const response = await this.post(url, data);
      if (response.status === 201) {
        return response;
      }
    } catch (err) {
      ErrorService.onError(err.response);
      return false;
    }
  }

  async removeUserFromUsergroup(usergroupId, userId) {
    try {
      const url = 
        path.join(
          `${this.USERGROUP_API_PATH}`,
          `/user-groups/${usergroupId}/members/${userId}/`);
      const response = await this.delete(url);
      if (response.status === 204) {
        return response.data;
      }
      return false;
    } catch (err) {
      ErrorService.onError(err.response);
      return false;
    }
  }

  async setUsergroupThumbnail(id, data) {
    const url = 
      path.join(
        `${this.USERGROUP_API_PATH}`,
        `user-groups/${id}/thumbnail/`);
    const response = await this.put(url, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  addParentToUsergroup(usergroupId, parentId) {
    const url = 
      path.join(
        `${this.USERGROUP_API_PATH}`,
        `user-groups/${usergroupId}/parents/`
    );
    return this.post(
      url,
      { parent_id: parentId}
    );
  }
}
const usergroupsAPI = new UsergroupsAPI();
export default usergroupsAPI;
